import { useModal } from "../hooks/useModal";

export default function CloseModal() {
  const { closeModal } = useModal();
  return (
    <button
      className="absolute top-4 right-4 p-1 rounded-lg z-10 text-gray-400 bg-transparent hover:text-gray-600 dark:hover:text-gray-300"
      onClick={closeModal}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        className="size-[18px]"
      >
        <path
          fillRule="evenodd"
          d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z"
          clipRule="evenodd"
        />
      </svg>
    </button>
  );
}
